import React from "react";
import { Icon } from "@iconify/react";
import { Card, CardActions, CardContent, Typography } from "@mui/material";

const classes = {
  root: {
    minWidth: 200,
    minHeight: 300,
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: "1 0 auto",
  },
  actions: {
    display: "flex",
    alignItems: "center",
  },
};

export default function MemberTypeCard(props) {
  const { memberType } = props;

  return (
    <Card style={classes.root}>
      <CardContent style={classes.content}>
        <div>
          <div style={{ minHeight: 80, position: "relative" }}>
            <div
              style={{
                position: "absolute",
                bottom: "10px",
                left: 0,
                right: 0,
              }}
            >
              {memberType.icon ? (
                memberType.icon
              ) : (
                <Icon width="40" icon="icon-park-solid:close-one" />
              )}
            </div>
          </div>
          <Typography style={{ minHeight: 80 }} variant="h5" component="h2">
            {memberType.text}
          </Typography>
          <hr></hr>
          <Typography variant="body2" component="p">
            {memberType.info}
          </Typography>
        </div>
      </CardContent>
      <CardActions style={classes.actions}>{props.children}</CardActions>
    </Card>
  );
}
